import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NotifserviceService {

  private _data:string;
  data$ = new Subject<any>();

  set data(data:any){
    this._data = data;
    this.data$.next(data);
  }

  get date() {
    return this._data;
  }
}
